import { usePermissions } from "../../context/PermissionContext";

const usePermission = () => {

  const { permissions } = usePermissions();

  const hasPermission = (moduleKey, permissionKey = "view") => {

    return !!permissions?.[moduleKey]?.[permissionKey];

  };

  return {
    hasPermission,
    permissions
  };
};

export default usePermission;